interface UseCookieConsentReturn {
  cookieConsent: boolean | null;
  showCookieBanner: boolean;
  acceptCookies: () => void;
  rejectCookies: () => void;
}

// The app uses only strictly-necessary first-party storage to remember the
// user's own preferences (feeds, theme, read-ids). Under GDPR/ePrivacy that
// does not require a consent banner, and showing one was creating friction
// the privacy story didn't actually need.
//
// The hook stays so existing call-sites keep compiling: it now always
// reports consent=true and never asks the user. Old `cookie_consent` cookies
// are left in place; they're just ignored.
export const useCookieConsent = (): UseCookieConsentReturn => {
  return {
    cookieConsent: true,
    showCookieBanner: false,
    acceptCookies: () => {},
    rejectCookies: () => {},
  };
};
